// extracted by mini-css-extract-plugin
export default {"link":"NoAccess_link__t30nM","smallArrow":"NoAccess_smallArrow__2KU8U"};